import { HTTP } from './http';
import config from 'config';

const baseUrl = config.mdLiveApi;

export const requestProviderList = (model) => new Promise((resolve, reject) => HTTP.post(
  model.id === 'default' ? `/mdlive/search-providers?patient_id=${model.patient_id}&page=${model.page}&per_page=30&mdlive_token=${model.token}` : `${baseUrl}/v2/patients/${model.id}/providers/search?page=${model.page}&per_page=30`,
  model.body,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestProviderSchedule = (model) => new Promise((resolve, reject) => HTTP.get(
  model.url === 'default' ? `/mdlive/providers-profile?provider_id=${model.id}&mdlive_token=${model.token}` : `${baseUrl}/v2/providers/${model.id}/profile`,
  model.config
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

// export const requestMessage = (model) =>
//   new Promise((resolve, reject) =>
//     HTTP.get(
//       model.url === `${baseUrl}messages/${model.id}/conversations`,
//       model.config
//     )
//       .then(response =>
//         (response.status === 200 ? resolve : reject)(response)
//       )
//       .catch(error => reject(error.response))
//   );



// WEBPACK FOOTER //
// ./client/api/provider.js